(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puflow-contact-draft"]) return;
  try {
    

function initPuflowContact(root) {
  root.querySelectorAll('.pfc').forEach(section => {
    if (section.dataset.pfcReady) return;
    const dialog = section.querySelector('.pfc-dialog');
    const reset = section.querySelector('[data-pfc-reset]');
    const form = section.querySelector('#ContactForm');
    if (!dialog || !reset || !form || typeof dialog.showModal !== 'function') return;
    section.dataset.pfcReady = 'true';
    reset.hidden = false;
    reset.addEventListener('click', () => dialog.showModal());
    section.querySelector('[data-pfc-cancel]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => reset.focus());
    section.querySelector('[data-pfc-confirm]').addEventListener('click', () => {
      form.querySelectorAll('input:not([type="hidden"]):not([type="submit"]), textarea').forEach(field => {
        field.value = '';
        field.removeAttribute('aria-invalid');
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      });
      section.querySelector('[data-pfc-cleared]').hidden = false;
      dialog.close();
      form.querySelector('input:not([type="hidden"])').focus();
    });
    section.querySelector('.pfc-ticket').addEventListener('click', event => {
      event.preventDefault();
      const target = section.querySelector('#Pfc-form-title');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initPuflowContact(document));
else initPuflowContact(document);
document.addEventListener('shopify:section:load', event => initPuflowContact(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puflow-m82-installation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('m82-installation')) {
    customElements.define('m82-installation', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.events = new AbortController();
        this.panels = Array.from(this.querySelectorAll('[data-m82-panel]'));
        this.steps = Array.from(this.querySelectorAll('[data-m82-step]'));
        this.dialog = this.querySelector('dialog');
        this.viewport = this.querySelector('[data-m82-viewport]');
        this.zoomButton = this.querySelector('[data-m82-zoom]');
        this.index = 0;
        this.backdropPressed = false;
        const listen = (node, name, handler) => node?.addEventListener(name, handler, { signal: this.events.signal });
        this.steps.forEach((button, index) => listen(button, 'click', () => this.showStep(index)));
        this.panels.forEach((panel, index) => listen(panel.querySelector('[data-m82-enlarge]'), 'click', event => this.openDiagram(index, event.currentTarget)));
        listen(this.querySelector('[data-m82-previous]'), 'click', () => this.showStep(this.index - 1));
        listen(this.querySelector('[data-m82-next]'), 'click', () => this.showStep(this.index + 1));
        listen(this.querySelector('[data-m82-close]'), 'click', () => this.dialog.close());
        listen(this.zoomButton, 'click', () => this.setZoom(this.dialog.dataset.zoom !== 'true'));
        listen(this.dialog, 'pointerdown', event => { this.backdropPressed = this.isBackdrop(event); });
        listen(this.dialog, 'pointercancel', () => { this.backdropPressed = false; });
        listen(this.dialog, 'click', event => {
          const dismiss = this.backdropPressed && this.isBackdrop(event);
          this.backdropPressed = false;
          if (dismiss) this.dialog.close();
        });
        listen(this.dialog, 'close', () => {
          this.backdropPressed = false;
          this.viewport.replaceChildren();
          if (this.imageOpener?.isConnected) this.imageOpener.focus({ preventScroll: true });
        });
        listen(document, 'shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.showStep(index);
        });
        if (this.panels.length) {
          this.showStep(0);
          this.querySelector('.m82-installation__steps').hidden = false;
          this.querySelector('.m82-installation__navigation').hidden = false;
        }
        this.classList.add('is-ready');
        this.mountVideo(this.events.signal);
      }

      disconnectedCallback() {
        this.events?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.querySelector('.m82-installation__video-entry > expandable-video')?.closePlayer?.();
        this.initialized = false;
      }

      showStep(index) {
        this.index = Math.max(0, Math.min(this.panels.length - 1, index));
        this.panels.forEach((panel, i) => { panel.hidden = i !== this.index; });
        this.steps.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
        this.querySelector('[data-m82-position]').textContent = `${this.index + 1} / ${this.panels.length}`;
        this.querySelector('[data-m82-previous]').disabled = this.index === 0;
        this.querySelector('[data-m82-next]').disabled = this.index === this.panels.length - 1;
      }

      openDiagram(index, opener) {
        const picture = this.panels[index].querySelector('picture');
        if (!picture || this.dialog.open) return;
        this.imageOpener = opener;
        const expanded = picture.cloneNode(true);
        expanded.querySelector('img').loading = 'eager';
        expanded.querySelector('img').removeAttribute('id');
        this.viewport.replaceChildren(expanded);
        this.querySelector('[data-m82-dialog-title]').textContent = this.panels[index].dataset.stepName;
        this.setZoom(false);
        this.dialog.showModal();
        this.viewport.scrollTo(0, 0);
      }

      setZoom(zoomed) {
        this.dialog.dataset.zoom = String(zoomed);
        this.zoomButton.textContent = zoomed ? this.dataset.zoomOut : this.dataset.zoomIn;
        this.zoomButton.setAttribute('aria-pressed', String(zoomed));
        this.viewport.querySelectorAll('img, source').forEach(image => { image.sizes = zoomed ? '220vw' : '94vw'; });
        if (!zoomed) this.viewport.scrollTo(0, 0);
      }

      isBackdrop(event) {
        const box = this.dialog.getBoundingClientRect();
        return event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
      }

      mountVideo(signal) {
        const source = this.querySelector('[data-m82-video]');
        if (!source || source.parentElement.querySelector('expandable-video')) return;
        customElements.whenDefined('expandable-video').then(() => {
          if (signal.aborted || !this.isConnected) return;
          const component = source.content.querySelector('expandable-video')?.cloneNode(true);
          if (!component) return;
          const video = component.querySelector('video');
          const button = component.querySelector('.expandable-video__open');
          if (!video || !button) return;
          video.autoplay = false;
          video.loop = false;
          video.preload = 'none';
          video.removeAttribute('autoplay');
          video.removeAttribute('loop');
          button.textContent = source.parentElement.dataset.watchLabel;
          button.setAttribute('aria-label', source.parentElement.dataset.watchLabel);
          source.parentElement.append(component);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
